<template>
  <div>

    <ForumPostEditorModal 
      :post_id="selected_post_id"
      ref="editor"
    />

    <m-row>
      <m-col lg="6">

        <Multiselect
          class="ml-2 multiselect-blue"
          v-model="selected_tag_ids"
          ref="tags-multiselect"
          mode="tags"
          :close-on-select="false"
          :filter-results="false"
          :min-chars="0"
          :resolve-on-load="true"
          :delay="0"
          :searchable="true"
          :options="async function(query) {
            return await fetch_tags(query);
          }"
        />
        

      </m-col>

      <m-col lg="6">
        <Multiselect
          class="ml-2 multiselect-blue"
          mode="tags"
          v-model="selected_cities"
          ref="cities-multiselect"
          :options="cities_options"
        />
      </m-col>
    </m-row>

    <memlist-static-table
      id="forum-posts-table"
      style="width: 100%; table-layout: fixed;"
      class="table-striped"
      :fields="headers"
      :items="items"
      head-variant="light"
    >
      <template #cell(text)="row">
        <div class="text-truncate" style="max-height: 4.5em; overflow: hidden;">
          {{ row.item.text }}
        </div>
      </template>

      <template #cell(tags)="row">
        <memlist-badge style="max-width: 86px;" v-for="tag in row.item.tags" :key="tag.id" class="mr-1">
          {{ tag.name }}
        </memlist-badge>
      </template>

      <template #cell(actions)="row">
        <div class="d-flex justify-content-end">
          <memlist-table-button
            svg="/assets/svg/pencil-square.svg"
            @click="edit_post(row.item.id)"
            :tooltip="$t('COMMON.EDIT')"
          />
          <memlist-table-button
            svg="/assets/svg/trash2.svg"
            @click="delete_post(row.item.id)"
            :tooltip="$t('COMMON.DELETE')"
          />
        </div>
      </template>
    </memlist-static-table>
  </div>
</template>


<script>
import axios from 'axios';
import ErrorPopup from '@/view/components/ErrorPopup.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js';
import ForumPostEditorModal from './ForumPostEditorModal.vue';

export default {
  name: 'ForumPostTable',
  components: { 
    ErrorPopup, 
    Multiselect,
    ForumPostEditorModal
  },
  mixins: [toasts],

  data() {
    return {
      selected_post_id: null,
      selected_cities: [],
      cities_options: [],
      items: [],
      all_tags: [],
      selected_tag_ids: [],
      error_popup_message: null,

      headers: [
        { key: 'author', label: this.$t('FORUM.AUTHOR'), sortable: true },
        { key: 'city', label: this.$t('FORUM.CITY'), sortable: true },
        { key: 'created_at', label: this.$t('FORUM.DATE'), sortable: true },
        { key: 'tags', label: this.$t('FORUM.TAGS'), sortable: false },
        { key: 'text', label: this.$t('FORUM.MESSAGE'), sortable: false, tdClass: 'td-overflow' },
        { key: 'actions', label: this.$t('COMMON.ACTIONS'), thClass: 'text-right' }
      ]
    };
  },

  watch: {
    selected_tag_ids: {
      handler() {
        this.load_posts();
      },
      deep: true
    },
    selected_cities: {
      handler() {
        this.load_posts();
      },
      deep: true
    }
  },

  computed: {
    tag_options() {
      return this.all_tags.map(tag => ({ id: tag.id, name: tag.name }));
    },
    
  },

  methods: {
    async load_cities() {
      const res = await axios.get('/forum_post/cities');
      this.cities_options = res.data.filter(i => i !== null && i !== "null");
    },
    async fetch_tags(query) {
      const res = await axios.get('/forum_post/tags');

      if (query && query.length > 0) {
        return res.data.filter(i => i.name.indexOf(query) >= 0).map(item => ({ label: item.name, value: item.id }));
      }

      return res.data.map(item => ({ label: item.name, value: item.id }));
    },
    async load_posts() {
      try {
        const res = await axios.get(`/forum_post`, {
          params: {
            tag_ids: this.selected_tag_ids.join(','),
            cities: this.selected_cities.join(','),
            q: this.search_text?.trim() || null
          }
        });

        this.items = res.data || [];
      } catch (err) {
        console.error('Error loading posts', err);
        this.error_popup_message = 'ERR_LOADING';
        this.$nextTick(() => { this.error_popup_message = null; });
      }
    },


    edit_post(id) {
      this.selected_post_id = id;
      this.$refs['editor'].show();
    },

    async delete_post(id) {
      try {
        const res = await axios.delete(`/forum_post/${id}`);
        if (res.status === 200 || res.status === 204) {
          this.items = this.items.filter(p => p.id !== id);
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Unable to delete post');
        }
      } catch (err) {
        console.error('Error deleting post', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), 'Unable to delete post');
      }
    }
  },

  async mounted() {
    await this.load_cities();
    await this.load_posts();
  }
};
</script>

<style scoped>
.td-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
